import { useEffect, useState } from 'react'

export function useLoadingTimeout(timeout: number = 5000) {
  const [isOver, setOver] = useState(false)

  useEffect(() => {
    const timerId = setTimeout(() => {
      setOver(true)
    }, timeout)

    return () => {
      clearTimeout(timerId)
    }
  }, [timeout])

  return [isOver]
}
